export default {
  sm: `
    Data is a key asset to ensure competitiveness of not just individuals, but of our region, society, and country.
    Protecting data that is our precious asset, "data sovereignty" is a critical challenge in the data age.
    DATA CENTER GAK promises to protect our data with our own technology with a sense of responsibility.
  `,
};
